
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index9WQxRc8ivzPAO5zVp3VWCahImxGOVxM6ge7DjvRiuH0Meta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/index.vue?macro=true";
import { default as _91id_93cKpWY_45RpGeMx1_Sl8INEN_45jQf8dZqVH_wpzwiD7RRNgMeta } from "/builds/bazinga/pharmasuisse/frontend/pages/form/[id].vue?macro=true";
import { default as indexdUQArWnAA7gthueLbyWLbHSMMWGmtQVmQjgJQKiNUQUMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/[id]/index.vue?macro=true";
import { default as indexBZWf9SrWoYobwJw6uhXcqnjd1vNqSK8EUL93mzqc9t8Meta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/[id]/orders/index.vue?macro=true";
import { default as index57ehimSuPSFHm5GeghVCvJP71ZnyL0V5ekezjkRTKGgMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/[id]/contact/index.vue?macro=true";
import { default as indexSc82_45RlKUqN_ZlFedMBD7z_45ZyH8bImaTJ_x7fJ4mxqAMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/[id]/administration/index.vue?macro=true";
import { default as indexItfFCCx_dqIUrWNHvObPwbeY1KRGuiLg4Ek3_45wRiOCMMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/[id]/pharmacies-overview/index.vue?macro=true";
import { default as _91id_93m89U1bEiHwdCYItC28SNszKMpLr5_45CdFiYAvrDj_GfoMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/[id].vue?macro=true";
import { default as indexPICMV3RkjoOgBbjEmpN6o4lfYVRVvooj8lF5YQdJVHEMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/cart/index.vue?macro=true";
import { default as indexY6XZ62OSShTMZq5XKVAj8f_awBNRvYVbZKF0lLbtxl8Meta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/shop/index.vue?macro=true";
import { default as index0g16W_45zJYPmNvQXNPPLnqjEjnhOK76DvZtuKKHrjG9YMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/events/index.vue?macro=true";
import { default as islands_45pagehCFc8CNtBeYzaKDZOIAigJhUqJRug2aOz4PYEU09iBUMeta } from "/builds/bazinga/pharmasuisse/frontend/pages/islands-page.vue?macro=true";
import { default as indexAXtGN6oJxKrdyJ3eQIRlFCJ9MnlGpbd2xsJAgmF8Q9wMeta } from "/builds/bazinga/pharmasuisse/frontend/pages/search/index.vue?macro=true";
import { default as indexln88Mu5FJhKjDInD8WkujJUbPyTs_45bufT7JrV6z9_45UEMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/signup/index.vue?macro=true";
import { default as indexU36dSQjFWFVGelChrB_S4_T5Mmyi_45taNwDGAUcHjGh8Meta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/articles/index.vue?macro=true";
import { default as indexy31ZKYCGDbvAnCkPPiRMnJS3SO6XxHWekuer7nrHAj4Meta } from "/builds/bazinga/pharmasuisse/frontend/pages/[...slug]/index.vue?macro=true";
import { default as index_EnyV1ndDoirqJcb5TIeZEK0eewjd3Ze8N9YtHrHN7MMeta } from "/builds/bazinga/pharmasuisse/frontend/pages/media/[id]/index.vue?macro=true";
import { default as indexnfMq2_45zHcK1t8oxJsbn1mlSKFTWb71WkCPl1s_45E5Uu8Meta } from "/builds/bazinga/pharmasuisse/frontend/pages/node/[nid]/index.vue?macro=true";
import { default as index_BAIWiFxDComwTluSfKyshHNY_45pzf8ve6MZQ_mUUHvQMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/login/index.vue?macro=true";
import { default as _91_46_46_46slug_93RN0Oi2p8zbUV3UtdOJll1dmvdJ7zINRNkpcbN6sGqIUMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/shop/[id]/[...slug].vue?macro=true";
import { default as indexgLMb7NQNEyxQQllbT1BvprF9DrtTbdU9W5Bjn_eUdT4Meta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/password/index.vue?macro=true";
import { default as indexSr404P_yFhlfaiG2ilvkkHsvUw2dEDDoVnfXnCXMUuEMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/press-releases/index.vue?macro=true";
import { default as _91id_93vt_45_45sFxlJaXWBxu12af01b5mZ77g6R_45cpuNLapz1pzUMeta } from "/builds/bazinga/pharmasuisse/frontend/pages/form/confirmation/[id].vue?macro=true";
import { default as indexzbWIgd7xm4vKOHHi_AcSMgX7sJ9RCIphuh2tYEhcwWUMeta } from "/builds/bazinga/pharmasuisse/frontend/pages/article/[...slug]/index.vue?macro=true";
import { default as loginbyeeOVFjTe_B5IMh53qQU9DuGyxjhuNJtGqRlPXBXmQMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/checkout/[orderId]/login.vue?macro=true";
import { default as _91uuid_93I_XVTuVlKmHI280uJoIWtcufmJETknNilYDmHMCX14UMeta } from "/builds/bazinga/pharmasuisse/frontend/pages/blokkli/library-item/[uuid].vue?macro=true";
import { default as complete9oZ1n76hc81EJiFOwdeDzWeBdq7D8h1PhuSppnQoG6QMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/checkout/[orderId]/complete.vue?macro=true";
import { default as indexbuIiVZOPmkQE0jkALlxEdUmcDSgb6M7mKLjCFHkfFisMeta } from "/builds/bazinga/pharmasuisse/frontend/pages/event/[nid]/[...slug]/index.vue?macro=true";
import { default as indexa1YkeketiuHqKCorVfREvozwJwTQvXg9wWhneJxr0NAMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/signup/account-exists/index.vue?macro=true";
import { default as indexkejrxdC8rob5Hru2WRwB5h68T5cQkJOkrhrwNRIspsoMeta } from "/builds/bazinga/pharmasuisse/frontend/pages/press-release/[...slug]/index.vue?macro=true";
import { default as indexS3G5LrnIowEbJoBrBBAglTpdXIzGEvC8apyeYvi_BrIMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/signup/number-not-found/index.vue?macro=true";
import { default as _91paragraphUuid_93okPr9gu2k0CMLtDYxD5FFQjhYP56B1BNrB_45HYaUnU5kMeta } from "/builds/bazinga/pharmasuisse/frontend/pages/print/paragraph/[nid]/[paragraphUuid].vue?macro=true";
import { default as index6Opu3ZcljpSfHaCtYFLVSO1sLi955fpeS2J4BQ4QoFsMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/switch-active-account/media/[id]/index.vue?macro=true";
import { default as indexpjYxU6CuOhagb9pJ2O2xFp3UHP7PPb2QRp8kP5SjLvsMeta } from "/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/activation/[uid]/[timestamp]/[hash]/login/index.vue?macro=true";
export default [
  {
    name: "home",
    path: "/",
    meta: index9WQxRc8ivzPAO5zVp3VWCahImxGOVxM6ge7DjvRiuH0Meta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/index.vue")
  },
  {
    name: "webform",
    path: "/form/:id()",
    meta: _91id_93cKpWY_45RpGeMx1_Sl8INEN_45jQf8dZqVH_wpzwiD7RRNgMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/pages/form/[id].vue")
  },
  {
    name: "user-route",
    path: "/user/:id()",
    meta: _91id_93m89U1bEiHwdCYItC28SNszKMpLr5_45CdFiYAvrDj_GfoMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/[id].vue"),
    children: [
  {
    name: "user-overview",
    path: "",
    meta: indexdUQArWnAA7gthueLbyWLbHSMMWGmtQVmQjgJQKiNUQUMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/[id]/index.vue")
  },
  {
    name: "user-orders",
    path: "orders",
    meta: indexBZWf9SrWoYobwJw6uhXcqnjd1vNqSK8EUL93mzqc9t8Meta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/[id]/orders/index.vue")
  },
  {
    name: "user-id-contact",
    path: "contact",
    meta: index57ehimSuPSFHm5GeghVCvJP71ZnyL0V5ekezjkRTKGgMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/[id]/contact/index.vue")
  },
  {
    name: "user-administration",
    path: "administration",
    meta: indexSc82_45RlKUqN_ZlFedMBD7z_45ZyH8bImaTJ_x7fJ4mxqAMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/[id]/administration/index.vue")
  },
  {
    name: "user-pharmacies-overview",
    path: "pharmacies-overview",
    meta: indexItfFCCx_dqIUrWNHvObPwbeY1KRGuiLg4Ek3_45wRiOCMMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/[id]/pharmacies-overview/index.vue")
  }
]
  },
  {
    name: "cart",
    path: "/cart",
    meta: indexPICMV3RkjoOgBbjEmpN6o4lfYVRVvooj8lF5YQdJVHEMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/cart/index.vue")
  },
  {
    name: "shop",
    path: "/shop",
    meta: indexY6XZ62OSShTMZq5XKVAj8f_awBNRvYVbZKF0lLbtxl8Meta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/shop/index.vue")
  },
  {
    name: "pharmasuisse-events-overview",
    path: "/events",
    meta: index0g16W_45zJYPmNvQXNPPLnqjEjnhOK76DvZtuKKHrjG9YMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/events/index.vue")
  },
  {
    name: "islands-page",
    path: "/islands-page",
    meta: islands_45pagehCFc8CNtBeYzaKDZOIAigJhUqJRug2aOz4PYEU09iBUMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/pages/islands-page.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: indexAXtGN6oJxKrdyJ3eQIRlFCJ9MnlGpbd2xsJAgmF8Q9wMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/pages/search/index.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: indexln88Mu5FJhKjDInD8WkujJUbPyTs_45bufT7JrV6z9_45UEMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/signup/index.vue")
  },
  {
    name: "articles",
    path: "/articles",
    meta: indexU36dSQjFWFVGelChrB_S4_T5Mmyi_45taNwDGAUcHjGh8Meta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/articles/index.vue")
  },
  {
    name: "drupal-route",
    path: "/:slug(.*)*",
    meta: indexy31ZKYCGDbvAnCkPPiRMnJS3SO6XxHWekuer7nrHAj4Meta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/pages/[...slug]/index.vue")
  },
  {
    name: "media-id",
    path: "/media/:id()",
    component: () => import("/builds/bazinga/pharmasuisse/frontend/pages/media/[id]/index.vue")
  },
  {
    name: "node-canonical",
    path: "/node/:nid()",
    meta: indexnfMq2_45zHcK1t8oxJsbn1mlSKFTWb71WkCPl1s_45E5Uu8Meta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/pages/node/[nid]/index.vue")
  },
  {
    name: "login",
    path: "/user/login",
    meta: index_BAIWiFxDComwTluSfKyshHNY_45pzf8ve6MZQ_mUUHvQMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/login/index.vue")
  },
  {
    name: "shop-product",
    path: "/shop/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93RN0Oi2p8zbUV3UtdOJll1dmvdJ7zINRNkpcbN6sGqIUMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/shop/[id]/[...slug].vue")
  },
  {
    name: "user-password",
    path: "/user/password",
    meta: indexgLMb7NQNEyxQQllbT1BvprF9DrtTbdU9W5Bjn_eUdT4Meta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/password/index.vue")
  },
  {
    name: "press-releases",
    path: "/press-releases",
    meta: indexSr404P_yFhlfaiG2ilvkkHsvUw2dEDDoVnfXnCXMUuEMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/press-releases/index.vue")
  },
  {
    name: "webform-confirmation",
    path: "/form/confirmation/:id()",
    meta: _91id_93vt_45_45sFxlJaXWBxu12af01b5mZ77g6R_45cpuNLapz1pzUMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/pages/form/confirmation/[id].vue")
  },
  {
    name: "article-slug",
    path: "/artikel/:slug(.*)*",
    meta: indexzbWIgd7xm4vKOHHi_AcSMgX7sJ9RCIphuh2tYEhcwWUMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/pages/article/[...slug]/index.vue")
  },
  {
    name: "checkout-login",
    path: "/checkout/:orderId()/login",
    meta: loginbyeeOVFjTe_B5IMh53qQU9DuGyxjhuNJtGqRlPXBXmQMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/checkout/[orderId]/login.vue")
  },
  {
    name: "blokkli-library-item-uuid",
    path: "/blokkli/library-item/:uuid()",
    meta: _91uuid_93I_XVTuVlKmHI280uJoIWtcufmJETknNilYDmHMCX14UMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/pages/blokkli/library-item/[uuid].vue")
  },
  {
    name: "checkout-complete",
    path: "/checkout/:orderId()/complete",
    meta: complete9oZ1n76hc81EJiFOwdeDzWeBdq7D8h1PhuSppnQoG6QMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/checkout/[orderId]/complete.vue")
  },
  {
    name: "event-nid-slug",
    path: "/event/:nid/:slug(.*)*",
    meta: indexbuIiVZOPmkQE0jkALlxEdUmcDSgb6M7mKLjCFHkfFisMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/pages/event/[nid]/[...slug]/index.vue")
  },
  {
    name: "signup-account-exists",
    path: "/signup/account-exists",
    meta: indexa1YkeketiuHqKCorVfREvozwJwTQvXg9wWhneJxr0NAMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/signup/account-exists/index.vue")
  },
  {
    name: "press-release-slug",
    path: "/medienmitteilung/:slug(.*)*",
    meta: indexkejrxdC8rob5Hru2WRwB5h68T5cQkJOkrhrwNRIspsoMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/pages/press-release/[...slug]/index.vue")
  },
  {
    name: "signup-number-not-found",
    path: "/signup/number-not-found",
    meta: indexS3G5LrnIowEbJoBrBBAglTpdXIzGEvC8apyeYvi_BrIMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/signup/number-not-found/index.vue")
  },
  {
    name: "print-paragraph",
    path: "/print/paragraph/:nid()/:paragraphUuid()",
    meta: _91paragraphUuid_93okPr9gu2k0CMLtDYxD5FFQjhYP56B1BNrB_45HYaUnU5kMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/pages/print/paragraph/[nid]/[paragraphUuid].vue")
  },
  {
    name: "switch-active-account-media-id",
    path: "/aktives-konto-wechseln/media/:mediaId(\\d+)",
    meta: index6Opu3ZcljpSfHaCtYFLVSO1sLi955fpeS2J4BQ4QoFsMeta || {},
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/switch-active-account/media/[id]/index.vue")
  },
  {
    name: "user-activation-uid-timestamp-hash-login",
    path: "/user/activation/:uid()/:timestamp()/:hash()/login",
    component: () => import("/builds/bazinga/pharmasuisse/frontend/sites/pharmasuisse/pages/user/activation/[uid]/[timestamp]/[hash]/login/index.vue")
  }
]